import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 精谕仓库-发送放货指令
export function postOutWhsInfo(data) {
  return request({
    url: URL.booking.jyWarehouse.postOutWhsInfo,
    method: 'post',
    data: data
  })
}

// 精谕仓库-发送放单指令
export function postRlsInfo(data) {
  return request({
    url: URL.booking.jyWarehouse.postRlsInfo,
    method: 'post',
    data: data
  })
}
// 精谕仓库-发送提箱指令
export function postTakeContPlan(data) {
  return request({
    url: URL.booking.jyWarehouse.postTakeContPlan,
    method: 'post',
    data: data
  })
}
// 精谕仓库-发送装箱指令
export function postContPreloadData(data) {
  return request({
    url: URL.booking.jyWarehouse.postContPreloadData,
    method: 'post',
    data: data
  })
}
// 校验是否已经放单
export function checkIfReleased(params) {
  return request({
    url: URL.booking.jyWarehouse.checkIfReleased,
    method: 'get',
    params
  })
}
// 校验对应的进仓编号是否已经放货
export function checkIfReleasedGoods(data, params) {
  return request({
    url: URL.booking.jyWarehouse.checkIfReleasedGoods,
    method: 'post',
    data,
    params
  })
}
// 放货列表
export function warehouseOutList(params) {
  return request({
    url: URL.booking.jyWarehouse.warehouseOutList,
    method: 'get',
    params
  })
}
// 精谕仓库接口日志
export function jyWarehouseApiLog(params) {
  return request({
    url: URL.booking.jyWarehouse.jyWarehouseApiLog,
    method: 'get',
    params
  })
}
// 获取拼箱动态列表
export function getJyLclDynamicList(params) {
  return request({
    url: URL.booking.jyWarehouse.getJyLclDynamicList,
    method: 'get',
    params
  })
}
